module.exports = __webpack_public_path__ + "img/131.5.ab415bed.png";